export default __webpack_public_path__ + "static/media/polo.ad76fda5.png";